<div [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>{{placeholder}}</mat-label>
    <input matInput [formControlName]="controlName" [required]="isRequired"/>
    <mat-error *ngIf="form.get(controlName).hasError('email')">
      <i>{{ 'ERROR.VALID_EMAIL' | translate }}</i>
    </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('maxlength')">
      <i>{{ 'ERROR.MAX_LENGTH' | translate: { length: form.get(controlName).getError('maxlength').requiredLength } }}</i>
    </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('required')">
      <i>{{ 'ERROR.REQUIRED' | translate }}</i>
    </mat-error>
  </mat-form-field>
</div>
